"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConstructorInstanceServerSide = exports.getConstructorInstanceClientSide = exports.getConstructorIndex = void 0;
const constructorio_client_javascript_1 = __importDefault(require("@constructor-io/constructorio-client-javascript"));
const getConstructorIndex = () => {
    const { CONSTRUCTOR_PUBLIC_INDEX_KEY } = process.env;
    return CONSTRUCTOR_PUBLIC_INDEX_KEY || '';
};
exports.getConstructorIndex = getConstructorIndex;
const constructorClientInstances = new Map();
const constructorNodeInstances = new Map();
const getConstructorInstanceClientSide = ({ userId }) => {
    var _a;
    const key = userId;
    if (!constructorClientInstances.has(key)) {
        const segments = typeof window !== 'undefined' && Array.isArray((_a = window === null || window === void 0 ? void 0 : window.cnstrc) === null || _a === void 0 ? void 0 : _a.userSegments)
            ? window.cnstrc.userSegments
                .map((segment) => segment === null || segment === void 0 ? void 0 : segment.toString())
                .filter((segmentString) => Boolean(segmentString))
            : undefined;
        constructorClientInstances.set(key, new constructorio_client_javascript_1.default({
            apiKey: (0, exports.getConstructorIndex)(),
            userId: Boolean(userId) && userId !== '0' ? userId : undefined,
            segments,
        }));
    }
    return constructorClientInstances.get(key);
};
exports.getConstructorInstanceClientSide = getConstructorInstanceClientSide;
const getConstructorInstanceServerSide = ({ userId }) => {
    // the window condition is required to not have an error of trying to require this library in client side and breaking the build
    const ConstructorIONode = typeof window === 'undefined' ? require('@constructor-io/constructorio-node') : null;
    const key = userId;
    if (!constructorNodeInstances.has(key)) {
        constructorNodeInstances.set(key, new ConstructorIONode({
            apiKey: (0, exports.getConstructorIndex)(),
            userId: Boolean(userId) && userId !== '0' ? userId : undefined,
        }));
    }
    return constructorNodeInstances.get(key);
};
exports.getConstructorInstanceServerSide = getConstructorInstanceServerSide;
